import {
  TImportMode,
  TSourceType,
} from './modal-import-sensor-settings.ts';

const sourceType: Record<TSourceType, string> = {
  asset: 'Iné zariadenie',
  file: 'Import súborov',
};

const ImportMode: Record<TImportMode, string> = {
  migrateMetadata: 'Vlastnosti signálu',
  importVirtualSignal: 'Virtuálne signály',
};

export default {
  copySensorSettings: 'Importovať vybrané nastavenia snímača',
  sourceAssetId: 'Zdrojové zariadenie',
  targetAssetId: 'Cieľové zariadenie',
  selectDataFormat: {
    placeholder: 'Vybrať formát dát',
    selected: 'Formát dát',
  },
  selectSource: {
    placeholder: 'Vybrať zdroj',
    selected: 'Zdroj',
    sentence: 'Importovať nastavenia snímača z {source} do {target}.',
    selectSourceType: 'Typ zdroja',
  },
  selectImportType: {
    placeholder: 'Vybrať typ importu',
    selected: 'Import: {importMode}',
    options: ImportMode,
  },
  sourceType,
  verifyMapping: {
    headline: 'Skontrolovať vlastnosti',
    selectAttributes: 'Vlastnosti na importovanie',
  },
  migrateProgress: {
    headline: 'Importovať nastavenia snímača',
  },
  errorTable: 'Počas migrácie sa vyskytli chyby',
  unknownFileValidationError: 'Nepodarilo sa overiť nahraný súbor. Dáta nezodpovedajú očakávaniam.',
  warning: {
    text: 'Zmeny vykonané počas migrácie sú nezvratné. Odporúča sa vopred stiahnuť zálohu nastavení snímača. Túto zálohu je možné neskôr importovať na obnovenie aktuálneho stavu',
    downloadBackup: 'Stiahnuť zálohu',
  },
  next: 'Ďalší',
  prev: 'Predchádzajúci',
};
